import { render, staticRenderFns } from "./MarketplaceFields.vue?vue&type=template&id=0d124a2d&"
import script from "./MarketplaceFields.vue?vue&type=script&lang=js&"
export * from "./MarketplaceFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports